import Typography from "@mui/material/Typography";
import { WebhookLogListTemplate } from "./WebhookLogListTemplate";

const COLUMNS = [
  { area: "received", label: "RECEIVED" },
  { area: "source", label: "SOURCE" },
  { area: "event", label: "EVENT" },
  { area: "outcome", label: "OUTCOME" },
  { area: "error", label: "ERROR" },
];

export const WebhookLogListHeader = () => {
  return (
    <WebhookLogListTemplate
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        pb: 1.5,
        px: 1,
      }}
    >
      {COLUMNS.map((column) => (
        <Typography
          key={column.area}
          sx={{ gridArea: column.area }}
          variant="subtitle2"
        >
          {column.label}
        </Typography>
      ))}
    </WebhookLogListTemplate>
  );
};
